<div class="loader-overlay" *ngIf="IsLoadingData">
    <div class="loader-overlay-box">
        <span class="fa fa-spinner fa-spin"></span>
    </div>
</div>
<div class="row">
    <div class="col-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons
            class="eotp-update-toolbar"
            [ContextMenuItems]="modelData.MainList.TableContextMenuItems" [actionService]="actionService"
            [ContextMenuIndicator]="'eprijemnica'"
        >
            <!-- <div style="width: 42%; text-align: left; margin-left: 2%;"> -->
            <div class="eotp-toolbar-title">
                <h2 style="display: inline-block; color: #71b1d1;">
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'eprijemnice/izeprijemnica'"><span
                            translate="EPRIJEMNICA.NEW.IZPRIJEMNICA"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'eprijemnice/uleprijemnica'"><span
                            translate="EPRIJEMNICA.NEW.ULPRIJEMNICA"></span></span>

                    <span *ngIf="baseUpdate.Item.ID > 0">
                        <span *ngIf="formControlDataName == 'eprijemnice/izeprijemnica'"><span
                                translate="EPRIJEMNICA.EDIT.IZEPRIJEMNICA"></span></span>
                        <span *ngIf="formControlDataName == 'eprijemnice/uleprijemnica'"><span
                                translate="EPRIJEMNICA.EDIT.ULPRIJEMNICA"></span></span>
                        <span style="padding-left: 5px">{{baseUpdate.Item.BrojPrijemnice}}</span>
                    </span>
                </h2>
            </div>
<!-- [translate]="baseUpdate.Item.StatusTooltip" -->
            <!-- <div style="padding-left: 5px; margin-right: 25px; margin-top: 10px;color: #71b1d1;"> -->
                <div class="eotp-toolbar-text" style="color: #71b1d1;">
                <span *ngIf="nazivStatusa"
                        text-align="center" 
                        [translate]="nazivStatusa">
                </span>
            </div>

           <div class="btn-group mr-1" *ngIf="formControlDataName == 'eprijemnice/izeprijemnica'">
                <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'EPRIJEMNICA.SEND.ACTION'"
                    [Container]="'body'" (clicked)="SendEReceipt(baseUpdate.Item)"
                    [IsDisabled]="baseUpdate.Item.ID==-1 || loadingSendEReceipt || !baseUpdate.Item.Editable || (baseUpdate.Item.StatusGenericName != null && baseUpdate.Item.StatusGenericName != '404')"
                    [Model]="'izeprijemnica'" [Action]="'Upload_XML_Sef_EPrijemnica'">
                    <i class="fas fa-file-export"></i>
                    <span *ngIf="loadingSendEReceipt" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                </yt-button>
            </div>
            <div class="btn-group mr-1">
                <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'EPRIJEMNICA.OSVEZISTATUS.ACTION'"
                    [NgStyle]="{'background-color':bojaStatusa}" [Container]="'body'" (clicked)="RefreshStatusClick()"
                    [Model]="'izeprijemnica'" [Action]="'Upload_XML_Sef_EPrijemnica'">
                    <i class="fas fa-sync-alt"></i>
                    <span *ngIf="loadingSendEReceipt" class="loader"><span
                            class="fa fa-spinner fa-spin"></span></span>
                </yt-button>
            </div>

            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eprijemnice/uleprijemnica'">
                <button class="btn btn-outline-primary" ngbTooltip="{{'EPRIJEMNICA.PRIHVATIPRIJEMNICU.ACTION' | translate}}"
                    container="body" (click)="PrihvatiPrijemnicu(baseUpdate.Item.ID)"
                    [disabled]="baseUpdate.Item.ID==-1 || baseUpdate.Item.StatusGenericName !== 'Received'"
                    >
                    <i class="fas fa fa-check"></i>
                    <span style="padding-left: 5px;" translate="EPRIJEMNICA.PRIHVATIPRIJEMNICU.SINGULAR"></span>
                </button>
            </div>

            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eprijemnice/uleprijemnica'">
                <button class="btn btn-outline-primary" ngbTooltip="{{'EPRIJEMNICA.ODBIJPRIJEMNICU.ACTION' | translate}}"
                    container="body" (click)="OdbijPrijemnicu(baseUpdate.Item.ID)"
                    [disabled]="baseUpdate.Item.ID==-1 || baseUpdate.Item.StatusGenericName !== 'Received'"
                    >
                    <i class="fas fa fa-times"></i>
                    <span style="padding-left: 5px;" translate="EPRIJEMNICA.ODBIJPRIJEMNICU.SINGULAR"></span>
                </button>
            </div>
            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eprijemnice/uleprijemnica'">
                <button type="button"
                    [disabled]="baseUpdate.Item.ID==-1"
                    (click)="PrintPDF()"
                    class="btn btn-primary"
                    ngbTooltip="{{'EPRIJEMNICA.PRINTPDF.ACTION' | translate}}"
                    container="body">
                    <span class="fa fa-fw fa-print"></span>
                </button>
            </div>
            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eprijemnice/uleprijemnica'">
                <button type="button"
                    [disabled]="baseUpdate.Item.ID==-1"
                    (click)="PreuzmiPriloge()"
                    class="btn btn-primary"
                    ngbTooltip="{{'EPRIJEMNICA.PREUZMIPRILOGE.ACTION' | translate}}"
                    container="body">
                    <span class="fa fa-solid fa-download"></span>
                </button>
            </div>
             
        </yt-fw-default-update-buttons>
    </div>
</div>
<yt-eprijemnica-update #baseUpdate></yt-eprijemnica-update>